<!-- Loader overlay with spinner, visible only when `isLoading` is true -->
<div *ngIf="isLoading" class="mypurchase-loader">
  <mat-spinner></mat-spinner>
  <p>{{message}}</p>
</div>